import { useMutation, useQueryClient } from '@tanstack/react-query';
import { CheckoutType } from '../app/types/checkoutType';
import { callApiSendOrder } from '../api/sendOrder';
import { useUserStore } from '../stores/userStore';
import { updateCheckoutCredit } from '../utils/checkBuyUtil';
import { UserSessionResponse } from '../app/types/sessionTypes';
import { queryKeys, queryConfigs } from '../config/reactQueryConfig';

// Adapter per convertire la response del backend al formato atteso dal frontend
const adaptOrderResponse = (response: any) => {
  return {
    status: response.success ? "Success" : "Failed",
    // Priorità al MongoDB ID per il numero ordine da mostrare all'utente
    result: response.mongoOrderId || response.partnerRequestNo || response.result
  };
};

export const useCreateOrder = () => {
  const queryClient = useQueryClient();
  const { user, setUser } = useUserStore();

  return useMutation({
    mutationFn: async (checkout: CheckoutType) => {
      const response = await callApiSendOrder(checkout);
      return adaptOrderResponse(response);
    },
    onSuccess: (data, variables) => {
      // Aggiorna la sessione utente con il nuovo credito
      if (user) {
        // updateCheckoutCredit restituisce WBToken, ma dobbiamo mantenere la struttura UserSessionResponse
        const updatedCredits = updateCheckoutCredit(user, variables);
        const updatedUser: UserSessionResponse = {
          ...user,
          credit100: updatedCredits.credit100,
          credit51c3: updatedCredits.credit51c3
        };
        setUser(updatedUser);
        
        // Log per debug
        console.log('Saldo aggiornato:', {
          prima: { credit100: user.credit100, credit51c3: user.credit51c3 },
          dopo: { credit100: updatedUser.credit100, credit51c3: updatedUser.credit51c3 },
          prodotto: variables.prodotto?.productname,
          prezzo: variables.prodotto?.fascia
        });
      } else {
        console.warn('Utente non trovato, impossibile aggiornare il saldo');
      }
    },
    onError: (error: any) => {
      console.error('Errore durante la creazione dell\'ordine:', error);
    },
    ...queryConfigs.orders
  });
};

// Hook per ottenere i dettagli di un ordine (per future implementazioni)
export const useOrderDetails = (orderId: string) => {
  return useMutation({
    mutationFn: async () => {
      // TODO: Implementare API call per ottenere dettagli ordine
      throw new Error('Non ancora implementato');
    }
  });
}; 